import {
  GETINQUIRYADMIN_SUCCESS,
  GETINQUIRYADMIN_FAILED,
  RESET_GETINQUIRYADMIN,
  LOADING_GETINQUIRYADMIN,
  NETWORK_ERROR_GETINQUIRYADMIN,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetInquiryAdmin = () => {
  return { type: RESET_GETINQUIRYADMIN };
};

const getInquirysAdmin = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETINQUIRYADMIN });
  await partnerServices
    .post("inquiry", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getInquiryAdminsuccess(res.data));
          break;
        case "success":
          dispatch(getInquiryAdminsuccess(res.data));
          break;
        default:
          dispatch(getInquiryAdminFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETINQUIRYADMIN, payload: err });
    });
};
function getInquiryAdminsuccess(data) {
  return {
    type: GETINQUIRYADMIN_SUCCESS,
    payload: data,
  };
}
function getInquiryAdminFailed(data) {
  return {
    type: GETINQUIRYADMIN_FAILED,
    payload: data,
  };
}

export { resetGetInquiryAdmin, getInquirysAdmin };
